<template>
  <layout>
    <rdkm-title>
      {{ $t('Доноры в работе') }}
    </rdkm-title>
    <div class="tile">
      <filter-form
        :patient="patient"
        :lrOrganizationId="filterQuery.lrOrganizationId"
        :tcOrganizationId="filterQuery.tcOrganizationId"
        :externalId="filterQuery.externalId"
        :donorStatuses="filterQuery.donorStatuses"
        :operatorId="filterQuery.operatorId"
        :patientId="filterQuery.patientId"
        :ageFrom="filterQuery.ageFrom"
        :ageTo="filterQuery.ageTo"
        :coincidence="filterQuery.coincidence"
        :gender="filterQuery.gender"
        v-on:reset="$refs.grid.filter(reset)"
        v-on:search="$refs.grid.filter($event, true)"
      >
      </filter-form>
      <br v-if="filterQuery.patientId" />
      <rdkm-grid
        ref="grid"
        :state="filterQuery"
        :emptyDataLabel="$t('Отсутствуют подходящие фенотипы')"
        :export="!!filterQuery.patientId"
        :isCheckable="patient && patient.status == 2"
        :export-url="exportUrl"
      >
        <grid-column
          name="idd"
          :title="$t('IDD')"
          width="120"
          cell="edit-cell"
          :url="function(row) { return `/donorsAtWork/${row.id}/${row.patientId}`; }"
        ></grid-column>
        <grid-column name="priority" v-if="canSetPriority" :title="$t('Приоритет')" width="100"></grid-column>
        <grid-column
          key="lrCode"
          :title="$t('Код РР')"
          :format="(v, row) =>  { return row.destLrCode || v; }"
          width="80"
          name="lrCode"
        ></grid-column>
        <grid-column width="120" :className="(row) => ( row.isTimeoutExpired ? 'red' : '')" name="timeout" :title="$t('Тайм-аут')" :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"></grid-column>
        <grid-column
          key="genderName"
          :title="$t('Пол')"
          width="100"
          name="genderNameLocalized"
        ></grid-column>
        <grid-column
          key="age"
          :title="$t('Возраст')"
          width="100"
          name="ageLocalized"
        ></grid-column>
        <grid-column
          key="statusName"
          :title="$t('Статус')"
          width="150"
          name="statusNameLocalized"
        ></grid-column>
        <grid-column v-if="canSetPriority" width="200" name="coordinatorNotes" :title="$t('Заметки')" :format="notes => notes ? notes.split('\n').slice(0, 3).join(' ') : ''"></grid-column>
        <grid-column
          key="statusDate"
          :title="$t('Дата статуса')"
          width="120"
          name="statusDate"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
        <grid-column
          key="collectionCenterName"
          :title="$t('Коллекшн-центр')"
          width="150"
          name="collectionCenterName"
        ></grid-column>
        <grid-column
          key="tcCode"
          :title="$t('Код ТЦ')"
          width="100"
          name="tcCode"
        ></grid-column>
        <grid-column
          key="operatorName"
          :title="$t('Координатор регистра')"
          v-if="!canSetPriority"
          width="200"
          name="operatorName"
        ></grid-column>
        <grid-column
          v-if="$auth.user().isRdkm"
          key="patientInfo"
          :title="$t('Пациент')"
          width="260"
          name="patientInfo"
          cell="edit-cell"
          :url="function(row) { return '/patients/' + row.patientId;}"
        ></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<style scoped>
.include-deleted {
  padding-top: 3px !important;
  font-size: 16px;
  line-height: 0;
}

input[type='file'] {
  display: none;
}
.custom-file-upload {
  color: #6c757d;
  border-radius: 3px;
  border: 2px solid #6c757d;
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
  padding: 6px 12px;
  margin-left: 10px;
  cursor: pointer;
}
.custom-file-upload:hover {
  color: white;
  background-color: #6c757d;
}

.swal-modal {
  width: 850px !important;
}
</style>

<script>
import Vue from 'vue';
import FilterForm from './Filter.vue';
import Grid from '../../components/grid/Grid.vue';
import GridColumn from '../../components/grid/GridColumn.vue';
import axios from 'axios';
import Constants from '../../constants';
import { EventBus } from '../../event-bus';
import DonorService from '../../services/donor.service.js';
import Swal from 'sweetalert2';

export default {
  props: ['query'],
  components: {
    'filter-form': FilterForm,
    'rdkm-grid': Grid,
    'grid-column': GridColumn,
  },
  data() {
    return {
      file: '',
      patient: null,
      filterQuery: {},
    };
  },
  beforeMount() {
    this.filterQuery = Object.assign({}, this.query);
    if (this.$auth.user().isLr) {
      this.filterQuery.lrOrganizationId = this.$auth.user().currentOrganization.id;
      //this.filterQuery.operatorId = this.$auth.user().id;
    }
  },
  created() {
    EventBus.$emit('showThrobber');

    const self = this;
    if (this.query.patientId) {
      axios.get('/patients/' + this.query.patientId).then((response) => {
        self.patient = response.data;
        EventBus.$emit('hideThrobber');
      });
    } else {
      EventBus.$emit('hideThrobber');
    }
  },
  computed: {
    exportUrl() {
      return (
        Constants.baseUrl +
        '/donors/ExportSearchResults?patientId=' +
        this.filterQuery.patientId +
        '&ageFrom=' +
        this.filterQuery.ageFrom +
        '&ageTo=' +
        this.filterQuery.ageTo +
        '&coincidence=' +
        this.filterQuery.coincidence +
        '&externalId=' +
        this.filterQuery.externalId
      );
    },
    canSetPriority: function() {
      return (
          this.$auth.user().functions.find(t => t.routeName === "SetDonorPriority") != null
      );
    },
    reset: function() {
      if (this.filterQuery.patientId) {
        return {
          ageFrom: 18,
          ageTo: 65,
          coincidence: 10,
        };
      } else {
        return {
          donorStatus: 1,
          operatorId: null,
        };
      }
    },
    isLrNameVisible: function() {
      return this.$auth.user().isRdkm && !this.filterQuery.patientId;
    },
    isOperatorVisible: function() {
      return this.$auth.user().isLr && !this.filterQuery.patientId;
    },
  },
  methods: {
    handleFileClick(event) {
      if (this.$auth.user().lrId || this.$auth.user().isLr) {
        return;
      }

      if (event) event.preventDefault();
    },
    handleImportFileUpload(event) {
      DonorService.import(this);
    },
    handleDownloadFile() {
      if (this.$auth.user().lrId || this.$auth.user().isLr) {
        window.open(
          Constants.baseUrl + '/donors/Export?userId=' + this.$auth.user().id
        );
      } else if (this.$auth.user().isRdkm) {
        window.open(
          Constants.baseUrl +
            '/donors/Export?userId=' +
            this.$auth.user().id +
            '&organizationId=' +
            this.filterQuery.organizationId
        );
      }
    },
  },
};
</script>
